import { Typography } from '@material-ui/core'
import React from 'react'

import {
  SectionContainer,
  SectionText,
  SectionTitle,
  DownloadLinks,
} from '../../_common'

import useStyles from './styles'

const Gobierno = () => {
  const { titleClass } = useStyles()

  const links = [
    {
      title:
        'Ley de disciplina financiera de las entidades federativas y los municipios',
      path: '../../../assets/disciplina-financiera.pdf',
      external: false,
    },
    {
      title: 'Ley de contabilidad gubernamental',
      path: '../../../assets/contabilidad-gubernamental.pdf',
      external: false,
    },
  ]

  return (
    <SectionContainer sectionID="gobierno">
      <SectionTitle title="Gobierno" />
      <SectionText text="Las entidades públicas están obligadas a observar los lineamientos de la Ley General de Contabilidad Gubernamental, así como de la Ley de disciplina financiera de las entidades federativas y sus municipios. En Global Actuarial Services, S.C., tenemos la experiencia y los conocimientos para apoyarlos en la cuantificación de los pasivos contingentes que se derivan de compromisos de su entidad. A continuación, se presentan los párrafos que mencionan estas obligaciones:" />
      <Typography className={titleClass}>Descargas</Typography>
      <DownloadLinks {...{ links }} />
    </SectionContainer>
  )
}

export default Gobierno
